import React, { useEffect, useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import "./CheckoutForm.css";
import axios from "axios";

export default function CheckoutForm(props) {
  const [amount, setAmount] = useState(0);
  const [amountToday, setAmountToday] = useState();
  const [currency, setCurrency] = useState("");
  const [clientSecret, setClientSecret] = useState(null);
  const [error, setError] = useState(null);
  const [metadata, setMetadata] = useState(null);
  const [succeeded, setSucceeded] = useState(false);
  const [processing, setProcessing] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  window.localStorage.clear();

  function SetPlanDescription() {
    if (props.subscriptionType === "distributor") {
      return (
        <div
          style={{ marginBottom: "20px", fontFamily: "Brandon med" }}
          className="plan-description-bullet-text"
        >
          ▸ Contact filmmakers directly
          <br />▸ Easy brokerage, get deals done
          <br />▸ Screen films missed at festivals
          <br />▸ Movies from around the world
          <br />▸ 50% Off Limited Time <br /><s>$15.95/month or $189.99 / Year</s> <br />now $7.95/month or $94.99 / Year
        </div>
      );
    }
    else if (props.subscriptionType === "audience") {
      return (
        <div
          style={{ marginBottom: "20px", fontFamily: "Brandon med" }}
          className="plan-description-bullet-text"
        >
          ▸  Stream from any device anytime
          <br />▸  New films launched daily
          <br />▸  Watch festival and student films
          <br />▸  View films, get points, win prizes
          <br />▸  Connect with global movie fans
          <br />▸  20% Off Limited Time <br /><s>$4.95/month or $54.99 / Year</s><br /> now $3.95/month or $43.99 / Year
        </div>
      );
    }
    else {
      return (
        <div
          style={{ marginBottom: "20px", fontFamily: "Brandon" }}
          className="plan-description-bullet-text"
        >
          ▸ Access to top decision makers
          <br />▸ Unlimited global screenings
          <br />▸ Marketing support and promotion
          <br />▸ Filmmaker cash awards
          <br />▸ 50% Off Limited Time <br /><s>$15.95/month or $189.99 / Year</s> <br />now $7.95/month or $94.99 / Year
        </div>
      );
    }
  }

  function addImdb() {
    {
      if (props.subscriptionType === "filmmaker") {
        return (
          <input
            type="text"
            id="imdbLink"
            name="imdbLink"
            placeholder="IMDb Link (Optional)"
            className="sr-input"
          />
        );
      }
    }
  }
  // CUSTOM FIELDS
  const [filmName, setFilmName] = useState("");
  const [submitterName, setSubmitterName] = useState("");
  const [subscriberEmail, setSubscriberEmail] = useState(
    "kristian.rolland@gmail.com"
  );
  const [billingFrequency, setBillingFrequency] = useState("monthly");
  const PROJECT_TITLE_SNIPPET = "Distributor";
  const [amountToBePaid, setAmountToBePaid] = useState("");

  // CUSTOM FIELDS

  const selectedColor = "rgb(74, 160, 199)";
  const unselectedColor = "#d9dadc";

  const monthlyFilmmakerPrice = "$7.95";
  const annualFilmmakerPrice = "$94.99";
  const monthlyDistributorPrice = "$7.95";
  const annualDistributorPrice = "$94.99";
  const monthlyAudiencePrice = "$3.95";
  const annualAudiencePrice = "$43.99";

  function handleMonthlyButtonClick() {
    setBillingFrequency("monthly");
    document.getElementById("monthly-div").style.display = "inline-block";
    document.getElementById("annual-div").style.display = "none";
    document.getElementById(
      "bill-frequency-monthly-select"
    ).style.backgroundColor = selectedColor;
    document.getElementById(
      "bill-frequency-annual-select"
    ).style.backgroundColor = unselectedColor;
    if (props.subscriptionType === "filmmaker") {
      setAmountToBePaid(monthlyFilmmakerPrice);
    } 
    else if (props.subscriptionType === "audience") {
      setAmountToBePaid(monthlyAudiencePrice);
    }
    else {
      setAmountToBePaid(monthlyDistributorPrice);
    }
    document.getElementById("hidden-free-trial-message").style.display =
      "block";
  }

  function handleAnnualButtonClick() {
    document.getElementById("hidden-free-trial-message").style.display = "none";
    document.getElementById("monthly-div").style.display = "none";
    document.getElementById("annual-div").style.display = "inline-block";
    setBillingFrequency("annual");
    document.getElementById(
      "bill-frequency-annual-select"
    ).style.backgroundColor = selectedColor;
    document.getElementById(
      "bill-frequency-monthly-select"
    ).style.backgroundColor = unselectedColor;
    if (props.subscriptionType === "filmmaker") {
      setAmountToBePaid(annualFilmmakerPrice);
    }
    else if (props.subscriptionType === "audience") {
      setAmountToBePaid(annualAudiencePrice);
    }
    else {
      setAmountToBePaid(annualDistributorPrice);
    }
  }

  window.addEventListener("load", (event) => {
    handleMonthlyButtonClick();
  });

  // CREATE CUSTOMER
  function createCustomer() {
    // console.log("creating customer")
    let billingEmail = document.getElementById("email").value;
    return fetch(
      "https://us-central1-festiv-fd5c6.cloudfunctions.net/subscriptions/create-customer",
      {
        // return fetch('http://localhost:5000/festiv-fd5c6/us-central1/subscriptions/create-customer', {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: billingEmail,
        }),
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        // result.customer.id is used to map back to the customer object
        return result;
      });
  }

  // STEP 1.5: SET ERRORS
  //   function displayErrorMessages(event) {
  //     displayError(event);
  //   }

  // function displayError(event) {
  //   // changeLoadingStatePrices(false);
  //   let displayError = document.getElementById('card-element-errors');
  //   if (event.error) {
  //     displayError.textContent = event.error.message;
  //   } else {
  //     displayError.textContent = '';
  //   }
  // }

  // STEP 2: CREATE PAYMENT METHOD
  async function createPaymentMethod(customerId) {
    // Set up payment method for recurring usage
    let billingName =
      document.getElementById("firstName").value +
      " " +
      document.getElementById("lastName").value;
    let priceId;
    let priceObj;

    if (props.subscriptionType === "filmmaker") {
      if (billingFrequency === "monthly") {
        // priceObj = await axios.get("http://localhost:5000/festiv-fd5c6/us-central1/subscriptions/price-id-filmmaker-monthly")
        priceObj = await axios.get("https://us-central1-festiv-fd5c6.cloudfunctions.net/subscriptions/price-id-filmmaker-monthly");
        priceId = priceObj.data.priceId;
      } else {
        priceObj = await (
          await axios.get("https://us-central1-festiv-fd5c6.cloudfunctions.net/subscriptions/price-id-filmmaker-annual")
        ).data.priceId;
        priceId = priceObj.data.priceId;
      }
    }
    else if (props.subscriptionType === "audience") {
      if (billingFrequency === "monthly") {
        // priceObj = await axios.get("http://localhost:5000/festiv-fd5c6/us-central1/subscriptions/price-id-filmmaker-monthly")
        priceObj = await axios.get("https://us-central1-festiv-fd5c6.cloudfunctions.net/subscriptions/price-id-audience-monthly");
        priceId = priceObj.data.priceId;
      } else {
        priceObj = await (
          await axios.get("https://us-central1-festiv-fd5c6.cloudfunctions.net/subscriptions/price-id-audience-annual")
        ).data.priceId;
        priceId = priceObj.data.priceId;
      }
    }
     else {
      if (billingFrequency === "monthly") {
        priceObj = (await axios.get("https://us-central1-festiv-fd5c6.cloudfunctions.net/subscriptions/price-id-distributor-monthly"));
        priceId = priceObj.data.priceId;
      } else {
        priceObj = (await axios.get("https://us-central1-festiv-fd5c6.cloudfunctions.net/subscriptions/price-id-distributor-annual"));
        priceId = priceObj.data.priceId;
      }
    }

    // console.log("Running Payment Method")
    // console.log("here are the billing details:")
    // console.log("Billing Name: " + billingName)
    // console.log("Price ID: " + priceId)
    // console.log("Price Object: " + priceObj)
    stripe
      .createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
        billing_details: {
          name: billingName,
        },
      })
      .then((result) => {
        if (result.error) {
          // console.log("Payment Method Did Not Work")
          // Delete User
          const config = {
            headers: {
              Authorization: window.localStorage.getItem("FBIdToken"),
            },
          };
          axios.post(
            "https://us-central1-festiv-fd5c6.cloudfunctions.net/api/deleteUser",
            JSON.stringify({}),
            config
          );
          window.localStorage.clear();
          alert(result.error.message);
          setProcessing(false);
          return;
        } else {
          createSubscription({
            customerId: customerId,
            paymentMethodId: result.paymentMethod.id,
            priceId: priceId,
          }).then((result) => {
            return;
          });
        }
      })
      .catch((error) => {
        // console.log(error)
        const config = {
          headers: {
            Authorization: window.localStorage.getItem("FBIdToken"),
          },
        };
        axios.post(
          "https://us-central1-festiv-fd5c6.cloudfunctions.net/api/deleteUser",
          JSON.stringify({}),
          config
        );
        window.localStorage.clear();
        alert(error.message);
      });
  }

  // STEP 3: DEFINE FUNCTION CALLS ABOVE
  function createSubscription({ customerId, paymentMethodId, priceId }) {
    // console.log("creating subscription")
    return (
      fetch(
        "https://us-central1-festiv-fd5c6.cloudfunctions.net/subscriptions/create-subscription",
        {
          // fetch('http://localhost:5000/festiv-fd5c6/us-central1/subscriptions/create-subscription', {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: window.localStorage.getItem("FBIdToken"),
          },
          body: JSON.stringify({
            customerId: customerId,
            paymentMethodId: paymentMethodId,
            priceId: priceId,
          }),
        }
      )
        .then((response) => {
          return response.json();
        })
        // If the card is declined, display an error to the user.
        .then((result) => {
          if (result.error) {
            // The card had an error when trying to attach it to a customer.
            throw result;
          }
          return result;
        })
        // Normalize the result to contain the object returned by Stripe.
        // Add the additional details we need.
        .then((result) => {
          return {
            paymentMethodId: paymentMethodId,
            priceId: priceId,
            subscription: result,
          };
        })

        // If attaching this card to a Customer object succeeds,
        // but attempts to charge the customer fail, you
        // get a requires_payment_method error.
        .then(handleRequiresPaymentMethod)
        // No more actions required. Provision your service for the user.
        .then(onSubscriptionComplete)
        .catch((error) => {
          console.log(error);
          // An error has happened. Display the failure to the user here.
          // We utilize the HTML element we created.
          // console.log(error)
          alert(error.message);
          window.localStorage.clear();
          setProcessing(false);
        })
    );
  }

  function onSubscriptionComplete(result) {
    alert("Payment Successful. Welcome To Festiv!");
    window.location.replace("https://festivmedia.com/subscriber-homepage");
    // console.log("Here's the status of your subscription:")
    // console.log(result.subscription.status)
    // Payment was successful.
    if (result.subscription.status === "active") {
      // Change your UI to show a success message to your customer.
      // Call your backend to grant access to your service based on
      // `result.subscription.items.data[0].price.product` the customer subscribed to.
    }
  }

  function handleRequiresPaymentMethod({
    subscription,
    paymentMethodId,
    priceId,
  }) {
    if (
      subscription.status === "active" ||
      subscription.status === "trialing"
    ) {
      // subscription is active, no customer actions required.
      return { subscription, priceId, paymentMethodId };
    } else if (
      subscription.latest_invoice.payment_intent.status ===
      "requires_payment_method"
    ) {
      // Using localStorage to manage the state of the retry here,
      // feel free to replace with what you prefer.
      // Store the latest invoice ID and status.
      localStorage.setItem("latestInvoiceId", subscription.latest_invoice.id);
      localStorage.setItem(
        "latestInvoicePaymentIntentStatus",
        subscription.latest_invoice.payment_intent.status
      );
      throw { error: { message: "Your card was declined." } };
    } else {
      return { subscription, priceId, paymentMethodId };
    }
  }

  function retryInvoiceWithNewPaymentMethod({
    customerId,
    paymentMethodId,
    invoiceId,
    priceId,
  }) {
    return (
      fetch("/retry-invoice", {
        method: "post",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          customerId: customerId,
          paymentMethodId: paymentMethodId,
          invoiceId: invoiceId,
        }),
      })
        .then((response) => {
          return response.json();
        })
        // If the card is declined, display an error to the user.
        .then((result) => {
          if (result.error) {
            // The card had an error when trying to attach it to a customer.
            throw result;
          }
          return result;
        })
        // Normalize the result to contain the object returned by Stripe.
        // Add the additional details we need.
        .then((result) => {
          return {
            // Use the Stripe 'object' property on the
            // returned result to understand what object is returned.
            invoice: result,
            paymentMethodId: paymentMethodId,
            priceId: priceId,
            isRetry: true,
          };
        })
        // Some payment methods require a customer to be on session
        // to complete the payment process. Check the status of the
        // payment intent to handle these actions.
        .then()
        // .then(handlePaymentThatRequiresCustomerAction)
        // No more actions required. Provision your service for the user.
        .then(onSubscriptionComplete)
        .catch((error) => {
          // An error has happened. Display the failure to the user here.
          // We utilize the HTML element we created.
          window.localStorage.clear();
          alert(error.message);
        })
    );
  }

  function isEmailValid() {
    //   For Valid Email:
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(document.getElementById("email").value)) {
      return true;
    } else {
      return false;
    }
  }
  function isFirstNameValid() {
    if (document.getElementById("firstName").value) {
      return true;
    } else {
      return false;
    }
  }
  function isLastNameValid() {
    if (document.getElementById("lastName").value) {
      return true;
    } else {
      return false;
    }
  }
  function isImdbLinkValid() {
    if (document.getElementById("imdbLink") && document.getElementById("imdbLink").value) {
      if (document.getElementById("imdbLink").value.includes("imdb.com/name")) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  function isPasswordValid() {
    if (document.getElementById("password").value.length > 5) {
      return true;
    } else {
      return false;
    }
  }

  function handleSubmit(event) {
    setProcessing(true);
    event.preventDefault();

    //FIRST, CHECK NOT EMPTY,ETC.
    event.preventDefault();

    if (!isEmailValid()) {
      setProcessing(false);
      alert("Please enter a valid email");
      return;
    }
    if (!isFirstNameValid()) {
      setProcessing(false);
      alert("Please enter a valid first name");
      return;
    }
    if (!isLastNameValid()) {
      setProcessing(false);
      alert("Please enter a valid last name");
      return;
    }
    if (!isImdbLinkValid()) {
      setProcessing(false);
      alert(
        "Optional: Your IMDB profile allows us to connect your account to films you've been involved with. Please enter a valid IMDb link Example: imdb.com/name/nm000000001"
      );
      return;
    }
    if (!isPasswordValid()) {
      setProcessing(false);
      alert("Please enter a password containing 6 or more characters");
      return;
    }

    // LET'S DO FIREBASE BEFORE STRIPE
    const returnJson = {
      firstName: document.getElementById("firstName").value,
      lastName: document.getElementById("lastName").value,
      password: document.getElementById("password").value,
      email: document.getElementById("email").value,
      accountType: props.subscriptionType,
    };
    // Check if IMDB Information Had Been Filled Out
    try {
      if (document.getElementById("imdbLink").value) {
        returnJson.imdbLink = document.getElementById("imdbLink").value;
      }
    } catch {}

    // Send Post Request To Create New Firebase User
    axios
      .post(
        "https://us-central1-festiv-fd5c6.cloudfunctions.net/api/createNewUser",
        returnJson
      )
      // axios.post("http://localhost:9000/festiv-fd5c6/us-central1/api/createNewUser", returnJson)

      .then((res) => {
        // console.log("got response", res)
        if (res.data.error) {
          window.localStorage.clear();
          alert(res.data.error);
          return;
        }
        return res;
      })
      .then((res) => {
        window.localStorage.setItem("FBIdToken", `Bearer ${res.data.token}`);
        return res;
      })
      .then((res) => {
        // STEP 1 CREATE CUSTOMER
        createCustomer().then((res) => {
          createPaymentMethod(res.customer.id);
        });
      })
      .then(() => {
        return;
      })
      // console.log(createPaymentMethod(customerObject.data.customer.id))

      .catch((err) => {
        setProcessing(false);
        window.localStorage.clear();
        alert(err.message);
        return;
      });
  }

  const renderSuccess = () => {
    return (
      <div className="sr-field-success message">
        <h1>Your payment is processing...</h1>
      </div>
    );
  };

  const renderForm = () => {
    const options = {
      style: {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      },
    };

    return (
      <div>
        <div className="w-layout-grid grid-20">
          <div className="div-block-61" style={{ width: "350px" }}>
            <h1 className="account-signup-page-title">
              {props.subscriptionType === "distributor"
                ? "Distributor"
                : props.subscriptionType === "audience"
                ? "Audience"
                : "Filmmaker"}
            </h1>
            <div
              style={{ width: "auto" }}
              onClick={handleMonthlyButtonClick}
              className="billing-frequency-button-card w-clearfix"
            >
              <div className="text-block-39">MONTHLY</div>
              <div className="plan-cost">
                {props.subscriptionType === "distributor"
                  ? monthlyDistributorPrice
                  : props.subscriptionType === "audience"
                  ? monthlyAudiencePrice
                  : monthlyFilmmakerPrice}
              </div>
              <div
                id="bill-frequency-monthly-select"
                className="billing-frequency-radio-div"
                style={{ backgroundColor: selectedColor }}
              ></div>
            </div>
            <div
              style={{ width: "auto" }}
              onClick={handleAnnualButtonClick}
              className="billing-frequency-button-card w-clearfix"
            >
              <div className="text-block-39">ANNUALLY ({props.subscriptionType === "audience" ? "20" : "50"}% OFF)</div>
              <div className="plan-cost">
                {props.subscriptionType === "distributor"
                  ? annualDistributorPrice
                  : props.subscriptionType === "audience"
                  ? annualAudiencePrice
                  : annualFilmmakerPrice}
                <br />
              </div>
              <div
                id="bill-frequency-annual-select"
                className="billing-frequency-radio-div"
              ></div>
            </div>
            <div className="plan-description">
              <div className="plan-description-title">
                {props.subscriptionType === "distributor"
                  ? "Click. Screen. Buy."
                  : props.subscriptionType === "audience"
                  ? "Shoes off. Movies on."
                  : "Your red carpet awaits."}
              </div>
              {<SetPlanDescription />}
            </div>
          </div>

          <div className="sign-up-card-wrapper">
            <form
              onSubmit={handleSubmit}
              id="subscribe-form"
              style={{
                backgroundColor: "white",
                padding: "25px",
                paddingTop: "10px",
                borderRadius: "8px",
              }}
            >
              <div className="sign-up-card-inner-title">
                Start your free trial today!
              </div>
              <div className="sr-combo-inputs">
                <div className="sr-combo-inputs-row">
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder="First Name"
                    // autoComplete="cardholder"
                    className="sr-input"
                  />
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    placeholder="Last Name"
                    // autoComplete="cardholder"
                    className="sr-input"
                  />
                </div>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email"
                  className="sr-input"
                />
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Password"
                  className="sr-input"
                />
                {addImdb()}

                <div className="sr-combo-inputs-row">
                  <CardElement
                    className="sr-input sr-card-element"
                    options={options}
                    // onChange = {displayErrorMessages}
                  />
                </div>
              </div>

              {error && <div className="message sr-field-error">{error}</div>}

              <div
                style={{ color: "#333e51", fontSize: "15px" }}
                id="total-amount"
                className="plan-description-title"
              >
                <div style={{ display: "inline-block", marginRight: "10px" }}>
                  Total:{" "}
                </div>
                <div id="monthly-div" style={{ display: "inline-block" }}>
                  $0
                </div>
                <div id="annual-div" style={{ display: "inline-block" }}>
                  {amountToBePaid}
                </div>
                <div
                  style={{
                    color: "rgba(0,0,0,.7)",
                    fontSize: "14px",
                    fontFamily: "Brandon re",
                  }}
                  id="hidden-free-trial-message"
                  className="plan-description-title"
                >
                  {amountToBePaid} per month after trial
                </div>
              </div>

              <button className="btn" disabled={processing || !stripe}>
                {processing ? "Processing…" : "Start Subscription"}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="checkout-form">
      <div className="sr-payment-form">
        <div style={{ display: "none" }} className="sr-form-row" />
        {succeeded ? renderSuccess() : renderForm()}
      </div>
    </div>
  );
}
